import { Button, Col, Table } from "antd";
import { BaseEntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IInitialData, IMetadata } from "../../components/entityManager/interfaces";
import CustomSpinner from "../../components/infrastructure/customSpinner";
import { enmEntityState, ICallOptions, IResultSet } from "../../components/infrastructure/models";
import { UserClaim } from "../userClaim";
import { IUser, IUserFetchingInfo, IUserProps, IUserStates } from "./interfaces";

export class User extends BaseEntityManager<IUser, IUserProps, IUserStates, IUserFetchingInfo, IInitialData> {
    static initMetadata = (): IMetadata => {
        return {
            name: "User",
            title: "کاربر",
            showHistory: true,
            Properties: [
                {
                    title: "نام کاربری",
                    dataIndex: "UserName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    disable: (sender: User) => {
                        return sender.state.currentEntity?.State !== enmEntityState.Added;
                    },
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام کاربری را وارد نمایید' }]
                },
                {
                    title: "کلمه عبور",
                    dataIndex: "Password",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.password,
                    width: 150,
                    showColumn: false,
                    showInLookup: false,
                    filterable: false,
                    sortable: false
                },
                {
                    title: "فعال؟",
                    dataIndex: "IsActive",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 150,
                },
                {
                    title: "نام",
                    dataIndex: "FirstName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "نام خانوادگی",
                    dataIndex: "LastName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام خانوادگی را وارد نمایید' }]
                },
                {
                    title: "ایمیل",
                    dataIndex: "Email",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.email,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "شماره تلفن همراه",
                    dataIndex: "Phone",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.numberinput,
                    formatter: value => {
                        const formated = `${value}`.length ? `0${value}`.replace(/\D+/g, '') : "";
                        return formated;
                    },
                    parser: value => {
                        const parsed = (value && value.length && value.startsWith('0') ? value.substring(1) : value) ?? "";
                        return parsed;
                    },
                    onKeyPress: (event, value) => {
                        if (!event.key.match(/\d/g) || `${value}`.length >= 10) {
                            event.preventDefault();
                        }
                    },
                    filterable: true,
                    width: 150,
                    showInLookup: false
                }
            ]
        };
    }
    private selectedRoles: React.Key[] = [];

    componentDidMount() {
        super.componentDidMount();
        this.getRoles();
    }
    onSelectedRolesChanged = async (selectedRowKeys: React.Key[]) => {
        this.selectedRoles = selectedRowKeys;

        this.fetchData();
    }
    getRoles = async () => {
        let opt: ICallOptions = {
            url: 'role/get',
            data: {},
            onSuccess: async (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    this.setState({
                        roles: result.Data
                    });
                }
            }
        };
        await this.callApi(opt);
    }
    onInitializing() {
        this.getDefaultState = () => {
            return {
                roles: [],
                selectedRoles: []
            };
        }
        if (!this.props.isLookupMode)
            this.rightSideExtraComponent = {
                render: () => (
                    <Table
                        loading={this.state.loading ? { indicator: <CustomSpinner /> } : false}
                        rowKey="RowGuid"
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: this.selectedRoles,
                            onChange: this.onSelectedRolesChanged
                        }}
                        pagination={{
                            style: { marginLeft: 10 },
                            size: "small"
                        }}
                        onHeaderRow={() => {
                            return {
                                className: 'ant-table-thead-checkbox',
                            };
                        }}
                        dataSource={this.state.roles}
                        className="box"
                        columns={[
                            {
                                dataIndex: "Description",
                                title: "فیلتر بر اساس نقش"
                            }
                        ]}
                    />),
                colSpan: 4
            };
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;
        this.renderingToolbar = () => {
            let userAccess = this.initialData?.AccessList["SaveUserClaims"];
            if (userAccess) {
                return (
                    <>
                        <Col style={{ marginLeft: 10 }}>
                            <Button type="default" onClick={this.onUserClaimsClick}>دسترسی ها</Button>
                        </Col>
                    </>);
            }
            else
                return <></>;
        };
        this.onDataFetching = (fetchingInfo: IUserFetchingInfo) => {
            fetchingInfo.RoleIds = this.selectedRoles.map(k => k as string);
        };
    }
    onUserClaimsClick = () => {
        this.addLookupForm("UserClaim",
            <UserClaim
                key="UserClaim"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { user: this.selectedEntity }
                }}
            />);
    }
}